$(function () {
  console.log("inclde_modals")
  var array = Array(0);
  // もしローカルストレージを持っていたら、配列として取得
  var arr = localStorage.getItem('localStorage_table_visible');
  if (arr) {
    var array = JSON.parse(arr);
    // ボタンとテーブルのクラスに一致するデータがあれば、アクティブにする
    array.forEach((element) => {
      $('.table-' + element).toggleClass('active');
      $('.table-check-btn-' + element).toggleClass('active');
    });
  }

  // arrにelemtnの値が存在するかチェックし、
  // 存在しない場合->追加
  // 存在する場合->削除
  function check_array(arr, element) {
    if (arr.includes(element)) {
      // ローカルストレージから削除
      arr = arr.filter(function (a) {
        return a !== element;
      });
      const serializedArray = JSON.stringify(arr);
      localStorage.setItem('localStorage_table_visible', serializedArray);
    } else {
      // ローカルストレージに保存
      arr.push(element);
      const serializedArray = JSON.stringify(arr);
      localStorage.setItem('localStorage_table_visible', serializedArray);
    }
  }

  //モーダル開閉
  $('.modal-btn').click(
    function () {
      console.log("click_modal")
      var click = $(this).data('modal');
      if ($('#add-collection-table-' + click).hasClass('active')) {
        $('#add-collection-table-' + click).toggleClass('active');
        $('#add-collection-table-' + click).stop().fadeOut().queue(function () {
          $('body').toggleClass('modal_active');
        });
      } else {
        $('#add-collection-table-' + click).toggleClass('active');
        $('#add-collection-table-' + click).stop().fadeIn()
        $('body').toggleClass('modal_active');
      }
    }
  );
  // チェックボックスをチェックすると、
  // ①ローカルストレージ更新
  // ②チェックボックス、テーブルの表示非表示を更新
  $('.table-check-btn').click(
    function () {
      // ローカルストレージ取得
      arr = localStorage.getItem('localStorage_table_visible');
      if (arr) {
        array = JSON.parse(arr);
      }
      console.log(arr)
      console.log(array)
      // クリックしたボタンのid取得
      var click = $(this).data('id');
      if ($(this).hasClass('active')) {
        check_array(array, click);
        // テーブルにチェックを入れる
        $('.table-' + click).toggleClass('active');
        $(this).toggleClass('active');
      } else {
        check_array(array, click);
        // テーブルにチェックからチェックをはずす
        $('.table-' + click).toggleClass('active');
        $(this).toggleClass('active');
      }
    }
  );
});